/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-09 11:28:02
 * @LastEditTime: 2020-07-31 13:57:06
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/modules/user.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
// import {setStore, getStore, removeStore} from '@/utils/store'
import { setStore, removeStore } from "@/utils/store";
import {
  getCaptchaApi,
  getTokenApi,
  getAuthorityApi,
  logout,
  getUserInfo,
  getUserMenu,
  getConfig,
  getUsersData,
  createUsers,
  getUsersInfo,
  deleteUsers,
  editUsers,
  getSSOConfig,
} from "@/service/userService";

const user = {
  state: {
    // ticket
    ticket: "",
    // org id
    org_id: "",
    // token
    token: ""
  },

  getters: {},

  mutations: {
    userClean(state, payload) {
      removeStore({ name: "userInfo" });
      state.userInfo = undefined;
    },
    /**
     * 保存token
     * @param {*} state state
     * @param {*} token
     */
    tokenSave(state, token) {
      state.token = token;
      setStore({ name: "unionToken", content: token, type: true });
    }
  },

  actions: {
    /**
     * 获取图形码
     * @param {*} store
     */
    getCaptchaUser(store) {
      return new Promise((resolve, reject) => {
        getCaptchaApi()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    /**
     *获取token
     * @user 用户信息对象
     */
    getTokenUser(store, user) {
      return new Promise((resolve, reject) => {
        getTokenApi(user)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    /**
     * 获取权限
     */
    getAuthorityUser(store) {
      return new Promise((resolve, reject) => {
        getAuthorityApi()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 退出登录
     */
    Todologout() {
      return new Promise((resolve, reject) => {
        logout()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 退出登录
     */
    TodoConfig() {
      return new Promise((resolve, reject) => {
        getSSOConfig()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取用户信息
     */
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取路由
     */
    getUserMenu() {
      return new Promise((resolve, reject) => {
        getUserMenu()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取全局配置信息
     */
    getConfig() {
      return new Promise((resolve, reject) => {
        getConfig()
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取user列表
     */
    getUsersData(store, info) {
      return new Promise((resolve, reject) => {
        getUsersData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 新建user
     */
    createUsers(store, data) {
      return new Promise((resolve, reject) => {
        createUsers(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取用户详情
     * @param {*} store
     * @param {*} id
     */
    getUsersInfo(store, id) {
      return new Promise((resolve, reject) => {
        getUsersInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除用户
     * @param {*} store
     * @param {*} id
     */
    deleteUsers(store, id) {
      return new Promise((resolve, reject) => {
        deleteUsers(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑用户
     * @param {*} store
     * @param {*} data
     */
    editUsers(store, data) {
      return new Promise((resolve, reject) => {
        editUsers(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js